import { Box, BoxProps, CheckBox, ColorOptions, Image, ImageProps, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { convertHexToRGBA } from '../../utils'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'

const LogoImage = ({ imgUrl, type }: { imgUrl: string; type: number }) => {
  const [imageUrl, setImageUrl] = useState(imgUrl)
  useEffect(() => {
    setImageUrl(imgUrl)
  }, [imgUrl])
  const onError = useCallback(() => {
    setImageUrl('')
  }, [])
  if (imageUrl) {
    return <Image {...styles.imageView} source={imageUrl} onError={onError} />
  }
  return (
    <Image
      {...styles.imageView}
      resizeMode="contain"
      source={
        type === PAYMENT_MODE_SUBTYPES.NB
          ? require('../../assets/images/bank.png')
          : require('../../assets/images/wallet.png')
      }
    />
  )
}

const getImage = (item: any, type: any) => {
  return <LogoImage imgUrl={item?.imageUrl ?? ''} type={type} />
}

const GridItem = ({ item, type, onItemChecked, isEdit, index, dataLength, itemHeight }: any) => {
  if (item?.text === undefined && item?.imageUrl === undefined) {
    return null
  }

  const isEmpty = item?.text?.length === 0 && item?.imageUrl?.length === 0
  const onCheckChange = (isChecked: string) => {
    onItemChecked(item.id, isChecked === 'true')
  }

  return (
    <ModBox
      h={itemHeight}
      show={!isEmpty}
      width={'100%'}
      borderRightWidth={index % 2 === 0 ? 1 : 0}
      borderRightColor={'BORDER_COLOR'}>
      <ModBox
        padding={15}
        flexDirection="row"
        alignItems="center"
        justifyContent={'center'}
        underlayColor={convertHexToRGBA('#2469FF', 10) as ColorOptions}>
        <Spacer direction="horizontal" size={8} />
        <ModBox width={16}>
          <CheckBox
            disabled={!isEdit}
            onChange={onCheckChange}
            iconSize={16}
            checked={item?.isSelected}
            color={isEdit ? 'BLUE_SHADE_PRIMARY' : 'DARK_GREY'}
          />
        </ModBox>
        <Spacer direction="horizontal" size={24} />
        <Box {...styles.logoContainer}>{getImage(item, type)}</Box>
        <Spacer direction="horizontal" size={8} />
        <ModBox show={!isEmpty} flex={1} marginLeft={8}>
          <Text {...styles.itemText} textAlign="left" numberOfLines={2} color={'#000000' as ColorOptions}>
            {item?.text ?? ''}
          </Text>
        </ModBox>
      </ModBox>
      <ModBox
        alignSelf={'center'}
        h={1}
        w={index === dataLength - 1 || index === dataLength - 2 ? '99.5%' : '100%'}
        backgroundColor={'BORDER_COLOR'}
        show={dataLength % 2 === 0 ? index !== dataLength - 1 && index !== dataLength - 2 : index !== dataLength - 1}
      />
    </ModBox>
  )
}

const styles = {
  textContainer: {
    marginHorizontal: 8,
    marginBottom: 16,
  },
  logoContainer: {
    height: 32,
    width: 32,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  } as BoxProps,
  separatorStyle: () => ({ height: 1, backgroundColor: convertHexToRGBA('#2469FF', 10) as ColorOptions } as BoxProps),
  itemText: {
    color: 'BLACK_75',
    fontSize: 12,
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: 'jiotype-medium',
  } as TextProps,
  imageView: {
    height: 32,
    width: 32,
  } as ImageProps,
}

export { GridItem }
